<template>
  <transition name="slide-fade">
    <box v-show="transitionShow" style="width:60vw;height: 50vh">
      <template v-slot:body>
        <!-- <img src="@/assets/lin-2.png" class="box-lin" /> -->
        <img src="@/assets/straight.gif" class="box-lin" />
        <div class="main">
          <p class="main-header">&nbsp;我該怎麼稱呼你？</p>
        </div>
        <div class="bottom">
          <div class="subscribe">
            <input
              type="text"
              v-model="username"
              placeholder="請輸入你的稱呼"
            />
            <button @click="goNext">
              <font-awesome-icon :icon="['fas', 'arrow-right']" size="lg" style="color:white"/>
            </button>
          </div>
        </div>
      </template>
    </box>
  </transition>
</template>
<script>
import Box from "@/components/Box";

export default {
  components: { Box },
  data() {
    return {
      username: null,
      transitionShow: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.transitionShow = true;
    }, 300);
  },
  methods: {
    goNext() {
      this.$store.dispatch("setUsername", this.username);
      this.$router.push("how");
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  margin-top: 5em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .main-header {
    margin-top: 1.2em;
    font-size: 2em;
    font-weight: bold;
    color: #965151;
    white-space: pre;
    display: inline-block;
    border: 1px solid transparent;
    border-width: 0 0 3px 0;
    border-image: linear-gradient(
      90deg,
      #965151 50%,
      rgba(150, 81, 81, 0.0224164) 104.35%,
      rgba(150, 81, 81, 0) 105.59%
    );
    border-image-slice: 1;
  }
}
.bottom {
  margin-top: 2.5em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.box-lin {
  position: absolute;
  bottom: -8em;
  right: -4em;
  height: 18vw;
}

.input {
  background-color: #fff;
  line-height: 2em;
  padding: 0.5rem 0.5rem;
  margin: 0.5rem 0;
  width: 50%;
  border-radius: 5px;
  border: none;
  outline: none;
  // outline-color: red;
}
.input:focus {
  box-shadow: 0 0 8px 0 #965151;
}

.subscribe {
  line-height: 2em;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  overflow: hidden;
  line-height: 2em;
  background-color: lighten(gray, 50%);

  input {
    border: 0;
    flex: 1;
    padding: 0.5rem 1rem;
    outline: none;
    background-color: transparent;
  }

  button {
    border: 0;
    height: 44px;
    width: 44px;
    // border-radius: 44px;
    // background-color: #1e90ff;
    background-color: lighten(#965151, 10%);
    cursor: pointer;
    transition: all 0.2s;
    outline: none;
    &:hover {
      // background-color: #0fb9b1;
      background-color: darken(#965151, $amount: 10%);
    }
  }
}

.slide-fade-enter-active {
  transition: all 2s ease;
}
.slide-fade-leave-active {
  transition: all 2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
